export default "__VITE_ASSET__d_mLQ4g3__"